/*
 * Login.jsx 05.12.2017
 *
 * (c) 2017 ergovia GmbH
 */
import React from 'react';
import {withStyles} from '@material-ui/core/styles';

const SECOND_IN_MILLISECONDS = 1000,
    DEFAULT_REFRESH_INTERVAL = 60;

const styles = {
    logoutText: {
        position: 'relative',
        marginTop: 100,
        textAlign: 'center'
    }
};

/**
 * Die Komponente für den Login.
 */
class Login extends React.Component {

    componentDidMount() {
        const tokenRefresh = DEFAULT_REFRESH_INTERVAL * SECOND_IN_MILLISECONDS;

        setInterval(function login() {
            this.props.refreshLogin();
            return login.bind(this);
        }.bind(this)(), tokenRefresh);
    }

    render() {

        const { classes } = this.props;

        const loggedIn = () => this.props.content();

        const loggedOut = () => <div>
            <p className={classes.logoutText}>Du bist leider nicht in stepnova angemeldet.</p>
        </div>;

        if (this.props.user.initial) {
            return null;
        }

        return this.props.user.data ? loggedIn() : loggedOut();

    }

}

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/de/ergovia/components/core/Login.jsx